import React, {useEffect, useState} from "react";
import PageTitle from "../../../components/common/page-title/PageTitle";
import {Link} from "react-router-dom";
import PrimaryButton from "../../../components/common/buttons/PrimaryButton";
import {FiPlus} from "react-icons/fi";
import CategoriesTable from "../../../components/tables/CategoriesTable";
import Category from "../../../classes/Category";

const PostsCategories = () => {

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        let isMounted = true;
        const controller = new AbortController();

        const fetchPostsCategories = async () => {
            try {
                const results = await Category.getPickableQuery().find();
                if (isMounted) {
                    setItems(results);
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        }

        fetchPostsCategories();

        return () => {
            isMounted = false;
            controller.abort();
        }

    }, []);

    return (
        <div>
            <PageTitle title="Posts categories">
                <Link to="./new">
                    <PrimaryButton title="New posts category" icon={<FiPlus/>}/>
                </Link>
            </PageTitle>
            <CategoriesTable items={items} loading={loading} />
        </div>
    );
};

export default PostsCategories;